import React from "react";
import Button from "@ui-kit/button";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { Card } from "@radarly/models/cards";
import useEmvRatioListModal from "../modals/emv-ratio-list";
import PeriodEvolution from "../shared/period-evolution";

export interface SharedPanelsCardEditionSidebarOptionsEmvProps {
  setCard?: (card: Card) => void;
  card?: Card;
}

export default function SharedPanelsCardEditionSidebarOptionsEmv({
  setCard,
  card,
}: SharedPanelsCardEditionSidebarOptionsEmvProps) {
  const locale = useCurrentUserLocale();
  const { onOpen, EmvRatioModal } = useEmvRatioListModal(
    locale,
    "RATIO_LIST_MODAL"
  );

  const onClickRatioExplainer = (e: Event) => {
    e.preventDefault();
    onOpen();
  };
  return (
    <>
      <EmvRatioModal />
      <Button onClick={(e) => onClickRatioExplainer(e)}>
        {tr(locale, "CUSTOM_PAGES::EDITION::DATAVIZ::RATIO_EXPLAINER")}
      </Button>
      <PeriodEvolution card={card} setCard={setCard} />
    </>
  );
}
